'use client'

import { PortableText } from '@portabletext/react'
import Image from 'next/image'
import { urlForImage } from '@/sanity/lib/image'
import Link from 'next/link'
import { PortableTextBlock } from '@portabletext/types'

interface RichTextProps {
	content: PortableTextBlock[]
}

export const RichTextComponents = {
	types: {
		image: ({ value }: any) => (
			<figure className="relative w-full my-section">
				<Image
					className={`w-full h-auto rounded-[8px] overflow-clip`}
					src={urlForImage(value).width(1440)?.url()}
					sizes='100vw'
					width={value?.asset?.metadata?.dimensions?.width}
					height={value?.asset?.metadata?.dimensions?.height}
					alt={value?.alt || ''}
					placeholder="blur"
					blurDataURL={value?.asset?.metadata?.lqip}
					quality={90}
				/>
			</figure>
		)
		// hr: () => <div><div className="hr block appearance-none h-0 border-solid border-blue-light border-b border-t-0 my-12 md:my-16" /></div>
	},
	block: {
		h2: ({ children } : any) => <h2 className="font-500 text-2xl leading-110">{children}</h2>,
		h3: ({ children } : any) => <h3 className="font-500 text-xl leading-110">{children}</h3>,
		h4: ({ children } : any) => <h4 className="font-500 text-lg leading-110">{children}</h4>,
		// normal: ({ children } : any) => <p className="font-400 text-lg leading-130">{children}</p>,
		blockquote: ({ children } : any) => <div className="blockquote my-section--sm"><blockquote className="font-500 text-2xl leading-115 text-grey dark:text-grey-dark">{children}</blockquote></div>,
	},
	marks: {
		link: ({ children, value }: any) => {
			const target = !value?.url?.startsWith('/') ? '_blank' : '_self'
			const rel = !value?.url?.startsWith('/') ? 'noreferrer noopener' : ''
			return target === '_blank' ? (
				<a
					href={value?.url}
					className="text-current hover:text-current hover:opacity-50 underline transition-all"
					rel={rel}
					target={target}
				>
					{children}
				</a>
			) : (
				<Link
					href={value?.url}
					className="text-current hover:text-current hover:opacity-50 underline transition-all"
					rel={rel}
					target={target}
				>
					{children}
				</Link>
			)
		}
	}
}

export default function RichText({ content }: RichTextProps) {
	return <PortableText value={content} components={RichTextComponents} />
}
